import Input from 'antd/lib/input';
import React from 'react';
import { connectField, filterDOMProps } from 'uniforms';
import wrapField from './wrapField';

var Text = function Text(props) {
  return wrapField(props, React.createElement(Input, Object.assign({
    disabled: props.disabled,
    id: props.id,
    name: props.name,
    onChange: function onChange(event) {
      return props.onChange(event.target.value);
    },
    placeholder: props.placeholder,
    ref: props.inputRef,
    type: props.type,
    value: props.value
  }, filterDOMProps(props))));
};

Text.defaultProps = {
  type: 'text'
};
export default connectField(Text);